import ReactDOM from 'react-dom';
import { App } from './Containers/App';
import React from 'react';

export const main = function (options) {
  const el = document.querySelector(`[data-studyplan]`);
  if (!el) return;
  ReactDOM.render(<App {...options} />, el);
};
